import { Controller } from '@hotwired/stimulus';

// SCSS clamps .review-body to 5 lines; JS toggles is-truncated / is-expanded from overflow.
export default class extends Controller {
  connect() {
    this.refresh();
    this.observer = new ResizeObserver(() => this.refresh());
    this.observer.observe(this.element);
  }

  disconnect() {
    this.observer.disconnect();
  }

  refresh() {
    const el = this.element;
    if (el.classList.contains('is-expanded')) return;

    const truncated = el.scrollHeight > el.clientHeight;
    el.classList.toggle('is-truncated', truncated);

    if (truncated) {
      el.setAttribute('tabindex', '0');
      el.setAttribute('role', 'button');
      el.setAttribute('aria-expanded', 'false');
    } else {
      ['tabindex', 'role', 'aria-expanded'].forEach((name) => el.removeAttribute(name));
    }
  }

  toggle(event) {
    const el = this.element;
    if (!el.matches('.is-truncated, .is-expanded')) return;

    event.preventDefault();
    const expanded = el.classList.toggle('is-expanded');
    el.classList.toggle('is-truncated', !expanded);
    el.setAttribute('aria-expanded', expanded);
  }
}
